import { createSlice } from "@reduxjs/toolkit";

export const wareHouseLocationSlice = createSlice({
  name: "wareHouseLocationSlice",
  initialState: {
    value: undefined,
    singleValue:undefined,
    destinationLocations:[]
  },
  reducers: {
    get_wareHouse_location_list: (state, action) => {
      state.value = action.payload.wareHouseLocationData;
    },
    get_wareHouse_location_single_view:(state,action)=>{
      state.singleValue=action.payload.singleWareHouseLocationData
    },
    get_wareHouse_destination_location_list: (state, action) => {
      state.destinationLocations = action.payload;
    },
  
  },
});

export const {get_wareHouse_location_list,get_wareHouse_location_single_view,get_wareHouse_destination_location_list} = wareHouseLocationSlice.actions;

export default wareHouseLocationSlice.reducer;